import { GetterTree } from 'vuex'
import { RouterState } from '@/store/modules/router/routerTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<RouterState, RootState> = {
  getNextUrl(state) {
    return state.nextUrl
  }
}
